import React from "react";

const Footer = () => {
	return (
		<footer className="page-footer footer">
			<div className="footer__social social">
				<h4 className="social__title">Our social networks:</h4>

				<ul className="social__list">
					<li className="social__item">
						<a href="#" className="social__link">
							<img
								src="./img/footer/fb.svg"
								className="social__img"
								alt="fb icon"
							/>
						</a>
					</li>
					<li className="social__item">
						<a href="#" className="social__link">
							<img
								src="./img/footer/insta.svg"
								className="social__img"
								alt="instagram icon"
							/>
						</a>
					</li>
					<li className="social__item">
						<a href="#" className="social__link">
							<img
								src="./img/footer/twitter.svg"
								className="social__img"
								alt="twitter icon"
							/>
						</a>
					</li>
				</ul>
			</div>

			<nav className="footer__nav nav">
				<ul className="nav__list">
					<li className="nav__item">
						<a href="#" className="nav__link">
							Main
						</a>
					</li>
					<li className="nav__item">
						<a href="#" className="nav__link">
							User's account
						</a>
					</li>
					<li className="nav__item">
						<a href="#" className="nav__link">
							Contacts
						</a>
					</li>
					<li className="nav__item">
						<a href="#" className="nav__link">
							Confidentiality
						</a>
					</li>
				</ul>
				<p className="footer__nav-autor">
					@ All rights reserved. ElSmart LLC 2022
				</p>
			</nav>

			<div className="footer__anchor anchor">
				<h4 className="anchor__title">Our social networks:</h4>
				<button type="button" className="anchor__button">
					<img
						src="./img/footer/arrow-top.svg"
						className="anchor__img"
						alt="arrow top"
					/>
				</button>
			</div>
		</footer>
	);
};

export default Footer;
